/* eslint-disable react/no-array-index-key */
import React, { useState, useRef, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
} from 'reactstrap';

export default function TwoFactorLoginModal({
  isOpen,
  toggle,
  maskedEmail,
  codeLength = 6,
  loading = false,
  error = null,
  onConfirm,
  onResend,
  resendLoading = false,
  resendError = null,
}) {
  const [inputs, setInputs] = useState(Array(codeLength).fill(''));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (isOpen) {
      setInputs(Array(codeLength).fill(''));
      setTimeout(() => {
        inputRefs.current[0]?.focus();
      }, 100);
    }
  }, [isOpen, codeLength]);

  const fillFrom = (startIndex, text) => {
    const digits = (text || '').replace(/\D/g, '');
    if (!digits) return;

    const newInputs = [...inputs];
    for (let i = 0; i < codeLength - startIndex; i += 1) {
      newInputs[startIndex + i] = digits[i] || newInputs[startIndex + i];
    }

    setInputs(newInputs);

    const lastFilled = Math.min(startIndex + digits.length - 1, codeLength - 1);
    setTimeout(() => inputRefs.current[lastFilled]?.focus(), 0);
  };

  const handleInputChange = (index, value) => {
    const digits = (value || '').replace(/\D/g, '');

    if (!digits) {
      const newInputs = [...inputs];
      newInputs[index] = '';
      setInputs(newInputs);
      return;
    }

    if (digits.length === 1) {
      const newInputs = [...inputs];
      newInputs[index] = digits;
      setInputs(newInputs);

      if (index < codeLength - 1) {
        inputRefs.current[index + 1]?.focus();
      }
      return;
    }

    fillFrom(index, digits);
  };
  /*
  const handleInputChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    const newInputs = [...inputs];
    newInputs[index] = value;
    setInputs(newInputs);

    if (value && index < codeLength - 1) {
      inputRefs.current[index + 1]?.focus();
    }
  };
  */

  const handleSubmit = () => {
    const codeEntered = inputs.join('');
    if (codeEntered.length !== codeLength) return;

    if (onConfirm) onConfirm(codeEntered);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !inputs[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const handleClose = () => {
    if (toggle) toggle();
    setInputs(Array(codeLength).fill(''));
  };

  return (
    <Modal isOpen={isOpen} toggle={handleClose}>
      <ModalHeader toggle={handleClose}>Verificação em 2 etapas</ModalHeader>
      <ModalBody>
        <p>
          Para sua segurança, enviamos um código de {codeLength} dígitos para o
          e-mail <b>{maskedEmail || 'cadastrado'}</b>.
        </p>

        <Row className="justify-content-center mb-3">
          {inputs.map((value, index) => (
            <Col xs={2} key={String(index)}>
              <Input
                type="text"
                maxLength={1}
                className="text-center font-weight-bold font-size-24"
                value={value}
                onChange={e => handleInputChange(index, e.target.value)}
                onPaste={e => {
                  e.preventDefault();
                  fillFrom(index, e.clipboardData.getData('text'));
                }}
                onKeyDown={e => handleKeyDown(e, index)}
                innerRef={ref => {
                  inputRefs.current[index] = ref;
                }}
              />
            </Col>
          ))}
        </Row>

        {error && <p className="text-danger text-center">{error}</p>}
        {resendError && (
          <p className="text-danger text-center">{resendError}</p>
        )}

        <div className="text-center">
          <Button color="link" disabled={resendLoading} onClick={onResend}>
            {resendLoading ? 'Reenviando...' : 'Reenviar código'}
          </Button>
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={loading || inputs.join('').length !== codeLength}
        >
          {loading ? 'Validando...' : 'Confirmar'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
